import React from "react";

import "../index.css";

export const Spinner = ({ color }) => {
  return <div id="spinner" style={{ borderColor: color || "black" }}></div>;
};
